import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useForm } from "react-hook-form";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import { safeText } from "../utils/hubHelpers";

export default function QuickReadingModal({ isOpen, toggle, machine, onSuccess }) {
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    if (!machine?.id) return;
    setLoading(true);
    try {
      const payload = {
        machineryId: machine.id,
        reading: data.reading,
        date: data.date || moment().format("YYYY-MM-DD"),
        remark: data.remark || "",
      };

      const res = await callApi(apiUrl.add_machinery_reading, {
        method: "POST",
        data: payload,
      });

      if (res?.status === true) {
        toast.success("Meter reading logged successfully!");
        reset();
        toggle();
        onSuccess?.();
      } else {
        toast.error(res?.message || "Failed to log reading");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader
          toggle={toggle}
          close={
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={toggle}
              aria-label="Close"
              style={{ filter: "invert(1) grayscale(100%) brightness(200%)", opacity: 0.9, cursor: "pointer" }}
            />
          }
          style={{ background: "#0f172a", color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between" }}
        >
          ⏱ Log Meter Reading: {safeText(machine?.name, "Machine")}
        </ModalHeader>
        <ModalBody>
          <div style={{ marginBottom: "1rem", background: "#f8fafc", padding: "0.6rem 0.9rem", borderRadius: 6, border: "1px solid #e2e8f0" }}>
            <p style={{ margin: 0, color: "#64748b" }}>
              Machine Reg: <strong style={{ color: "#0f172a" }}>{safeText(machine?.machineNumber, "N/A")}</strong> | Site: <strong style={{ color: "#0f172a" }}>{safeText(machine?.Site?.name || machine?.Site, "N/A")}</strong>
            </p>
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label className="form-label">
              Current Reading ({safeText(machine?.readingType, "Hours / KM")}) *
            </label>
            <input
              type="number"
              step="any"
              className="form-control"
              placeholder="e.g. 4250"
              {...register("reading", { required: "Reading is required" })}
            />
            {errors.reading && <small className="text-danger">{errors.reading.message}</small>}
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label className="form-label">
              Reading Date *
            </label>
            <input
              type="date"
              className="form-control"
              defaultValue={moment().format("YYYY-MM-DD")}
              {...register("date", { required: "Date is required" })}
            />
          </div>

          <div>
            <label className="form-label">
              Remarks / Operator Notes
            </label>
            <textarea
              className="form-control"
              rows={3}
              placeholder="Shift reading or special notes..."
              {...register("remark")}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={loading} style={{ background: "#2563eb", borderColor: "#2563eb" }}>
            {loading ? "Saving..." : "Save Reading"}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
